import { createAction, props } from '@ngrx/store';

export enum PatientAuditQueryType { Patient, Visit }

export interface PatientAuditQuery {
	queryType: PatientAuditQueryType;
	visitId: string;
	maxResults: number;
}

export interface PatientAuditFilters {
	fromDate: string;
	toDate: string;
	userId: number | null;
}

export enum PatientAuditActionTypes {
	QueryAndFiltersInitialised = '[Effect] Query And Filters Initialised',
	QueryChanged = '[Component] Query Changed',
	FiltersChanged = '[Component] Filters Changed',
	AuditLogChanged = '[Effect] Audit Log Changed',
	SortDirectionChanged = '[Component] Sort Direction Changed',
	DisplayCountChanged = '[Component] Display Count Changed'
}

export const queryAndFiltersInitialised = createAction(
	PatientAuditActionTypes.QueryAndFiltersInitialised,
	props<{ query: Partial<PatientAuditQuery> }>()
)

export const queryChanged = createAction(
	PatientAuditActionTypes.QueryChanged,
	props<{ query: Partial<PatientAuditQuery> }>()
)

export const filtersChanged = createAction(
	PatientAuditActionTypes.FiltersChanged,
	props<{ filters: Partial<PatientAuditFilters> }>()
)

export const auditLogChanged = createAction(
	PatientAuditActionTypes.AuditLogChanged,
	props<{ auditLog: any[] }>()
)

export const sortDirectionChanged = createAction(
	PatientAuditActionTypes.SortDirectionChanged
)

export const displayCountChanged = createAction(
	PatientAuditActionTypes.DisplayCountChanged
)